<script>
  import { link } from "svelte-spa-router";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import * as ls from "local-storage";

  export let _id;
  export let name;
  export let address;
  export let tel;
  export let email;

  let authData = {
    headers: { authorization: ls.get("jwt") },
  };

  onMount(() => {});

  const dispatch = createEventDispatcher();

  const handleDelete = async () => {
    let resItem = await axios.get(
      `${$config.backendURL}/items/with-supplier/${_id}`,
      authData
    );

    let length = resItem.data.length;

    if (length > 0) {
      alert(
        `${name} is being used in ${length} items in Materials Stock.\n\nYou cannot delete this record at the moment!`
      );
      return;
    }

    let confirmDelete = confirm(`Do you wish to delete ${name}?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/suppliers/${_id}`, authData)
        .then((res) => {
          dispatch("delete");
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };
</script>

<div class="tr tracking-wider border-b border-gray-100 ">
  <div style="min-width: 10rem; max-width: 10rem;" class="flex items-center">
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <a
      href={`/suppliers/${_id}`}
      use:link
      class="text-base btn btn-gray-outline"
    >
      <i class="fas fa-eye" />
    </a>
  </div>
  <div style="min-width: 20rem; max-width: 20rem;">{name}</div>
  <div style="min-width: 10rem; max-width: 10rem;">{tel}</div>
  <div style="min-width: 15rem; max-width: 15rem;">
    {email}
  </div>
  <div style="min-width: 25rem; max-width: 25rem;">
    {address}
  </div>
</div>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
